export default __webpack_public_path__ + "static/media/Google.b9361a38.svg";